import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function ValidateUniqueField<T>(items: T[] | null, field: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (items && items.find(item => String(item[field]).toLowerCase() === String(value).toLowerCase())) {
      return { duplicate: true }
    } 
    return null;
  }
}